import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";

import "animate.css/animate.css";

const SecondModal = ({
  classes,
  nextQuestion,
  handleClose,
  answeredCorrectly,
  question,
  isOpen
}) => {
  return (
    <Modal open={isOpen}
    className="animate__animated animate__fadeInRight"
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          <Typography className={classes.stepNumber}>STEP 2</Typography>
          <Grid container justify="center" className={classes.mainLine}>Now we have only people that in the labor force, you can decide which "Friends" are employed or unemployed.</Grid>
          <Typography className={classes.evalDesc}>
            How do you know? Anyone who is working, even part time, is classified as employed.
          </Typography>
          <Grid container justify="center" style={{ padding: 24 }}>
            <Button className={classes.submitButton} onClick={handleClose}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(SecondModal);
